/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDetailsCompany
 */
export interface UserDetailsCompany {
    /**
     * 
     * @type {number}
     * @memberof UserDetailsCompany
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsCompany
     */
    name: string | null;
}

/**
 * Check if a given object implements the UserDetailsCompany interface.
 */
export function instanceOfUserDetailsCompany(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function UserDetailsCompanyFromJSON(json: any): UserDetailsCompany {
    return UserDetailsCompanyFromJSONTyped(json, false);
}

export function UserDetailsCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDetailsCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function UserDetailsCompanyToJSON(value?: UserDetailsCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

